import { intercomSendData } from "./intercomHelper";

export default function registerUserSessionToIntercom(user) {
  try {
    const currentUser = "id" in user ? user : user.user_session.user;

    const intercomDataUser = {
      id: currentUser.id,
      name: currentUser.full_name,
      email: currentUser.email
    };

    intercomSendData(intercomDataUser);
  } catch (err) {
    console.error(err);
  }
}
